import { IEarlyEnrollmentState } from "../interfaces/iearly-enrollment-status";

export const EARLYENROLLMENT_STATE: IEarlyEnrollmentState = {
    paymentData: {},
    paymentResumeData: {},
    studentData: {},
    subjectsData: {},
    active: false
};
